module.exports = __webpack_public_path__ + "static/media/Yenepoya Photos-3.e3cc0518.png";